import { useEffect, useRef, useState } from 'react';

export default function About() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const paragraphs = [
    "I'm Alinur Arafat, a multidisciplinary designer who believes that great design isn't about decoration—it's about solving problems with elegance and intention.",
    "My work spans across website building, UI/UX design, graphic design, video editing, and social media management. Each discipline informs the others, creating a holistic approach to digital experiences.",
    "I focus on clarity, usability, and visual impact. Every project is an opportunity to strip away the unnecessary and reveal what truly matters. The result? Experiences that feel natural, intuitive, and effortless.",
    "Whether I'm designing a brand identity, building a website, or crafting a social media strategy, my goal remains the same: to create work that resonates, performs, and endures."
  ];

  return (
    <section
      id="about"
      ref={sectionRef}
      className="relative py-32 px-6 bg-[#F8F9FB]"
    >
      <div className="max-w-4xl mx-auto">
        <h2
          className="text-5xl md:text-6xl font-bold text-black mb-16 leading-tight"
          style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.02em' }}
        >
          Who I Am
        </h2>

        <div className="space-y-8">
          {paragraphs.map((text, index) => (
            <p
              key={index}
              className={`text-xl md:text-2xl text-black/70 leading-relaxed transition-all duration-700 delay-${index * 100}`}
              style={{
                fontFamily: 'Inter, sans-serif',
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transitionDelay: `${index * 150}ms`,
              }}
            >
              {text}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
